var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowActiveUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.444,
    height: 26.409,
    viewBox: "0 0 16.444 26.409",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_936",
    "data-name": "Group 936",
    transform: "translate(-253.451 -211.859)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_470",
    "data-name": "Path 470",
    d: "M4510.741,238.267l9.154-13.2-9.154-13.2h-7.29l9.154,13.2-9.154,13.2Z",
    transform: "translate(-4250)",
    fill: "#693f23"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowActiveUser);
export default __webpack_public_path__ + "static/media/Arrow-active-user.fd069483de40336e2ebf61c8c7bfd080.svg";
export { ForwardRef as ReactComponent };